import React, { useState, useEffect } from "react";
import {
  View,
  StyleSheet,
  Text,
  TouchableOpacity, 
  //ImageBackground,
  Dimensions,
  Image,
  Platform
} from "react-native";
//import { Image } from "react-native-expo-image-cache";
import colors from "../config/colors";
import { Video } from 'expo-av';
import connectionConfig from '../config/settings';
import Foundation from 'react-native-vector-icons/Foundation';
import ActivityIndicator from "../components/ActivityIndicator";
import VideoVisor from "../components/VideoVisor";


var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
//var widthImage = (windowWidth * 1)
//var heightImage = (windowWidth * .85)
function ImageHandlerDichapp({ 
    imageUrl, 
    userId,
    youtubeCode = '',
    styleImage,
    styleImageVideo,
    imageType,
    iconColor = colors.green,
    iconSize = 30,
    navigation,
    routes,
    btnImage,
    onPressImg
 }) {
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(false)
  //const navigation = useNavigation();
  // useEffect(() => {     

  //   setMesageVisible(imageUrl)
  // }, []); 

       // Switch para S3 o servidor
      var profileUri = ''
      var webUrl = ''
   
     if (connectionConfig.switchS3 === true) {
       profileUri = connectionConfig.imageUrlS3
       webUrl = connectionConfig.imageUrlS3
       //seedVideoUri = connectionConfig.imageUrlS3
       // console.log('CardRequiremants -> guarda las imagenes en un bucket de aws S3  ', webUrl + userId +'_'+ imageUrl.substring(0, 19) + '_userfit.jpg' )
     } else {
       console.log('CardRequiremants -> else switchS3')
       webUrl = connectionConfig.imageUrl + '/seedImages/'
       profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
       //seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
     }
  //debugger
 // console.log('imageUrl en ImageHandlerDicapp ->', webUrl + imageUrl )
    //console.log('imageUrl en ImageHandlerDicapp 3 ' , webUrl )

  switch (imageType) {
    case 'seedConcat':
            return (
                <View >
                <ActivityIndicator visible={loading} />
                {
                    //.............................................
                    //Sección que pinta video de youtube
                    //.............................................
                    youtubeCode === '' ?
                    null
                    :
                    <View style={styles.image}>
                        <VideoVisor videoNumber={youtubeCode} />
                    </View>
                }
                {
                    imageUrl === null ?
                    null
                    : imageUrl === undefined ?
                    null
                    :
                    imageUrl.includes('Poner Foto') ?
                    <Foundation name="mountains" size={iconSize} color={iconColor} />

                    :imageUrl.includes('.mp4') ?
                        <Video
                        // ref = {video}
                        style={styleImageVideo}
                        source={{
                            uri:  imageUrl
                        }}
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />

                    : imageUrl.includes('mov') ?
                        <Video
                            // ref = {video}
                            style={styleImageVideo}
                            source={{
                            uri: imageUrl
                            }}
                            useNativeControls
                            resizeMode="contain"
                            isLooping
                            onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />
                    
                        :  imageUrl.endsWith('.png') ?
                            <> 
                                {
                                    Platform.OS === 'ios' ?
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri: imageUrl  }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                    :
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri: imageUrl }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                }                          
                            </>                          
                        : imageUrl.endsWith('.jpg') ?
                            <> 
                                {
                                    Platform.OS === 'ios' ?
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri:  imageUrl  }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                    :
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri:  imageUrl }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                }                          
                            </>
                            :                           
                            null
                        } 
                </View>
            );
    case 'seed':
            return (
                <View //style={styleImage}
                >
                <ActivityIndicator visible={loading} />
                {
                    //.............................................
                    //Sección que pinta video de youtube
                    //.............................................
                    youtubeCode === '' ?
                    null
                    :
                    <View style={styles.image}>
                        <VideoVisor videoNumber={youtubeCode} />
                    </View>
                }
                {
                    imageUrl === null ?
                    null
                    : imageUrl === undefined ?
                    null
                    :
                    imageUrl.includes('Poner Foto') ?
                    <Foundation name="mountains" size={iconSize} color={iconColor} />

                    :imageUrl.includes('.mp4') ?
                        <Video
                        // ref = {video}
                        style={styleImageVideo}
                        source={{
                            uri: webUrl + imageUrl
                        }}
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />

                    : imageUrl.includes('mov') ?
                        <Video
                            // ref = {video}
                            style={styleImageVideo}
                            source={{
                            uri: webUrl + imageUrl
                            }}
                            useNativeControls
                            resizeMode="contain"
                            isLooping
                            onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />
                    
                        : imageUrl.endsWith('.png') ?
                            <> 
                                <TouchableOpacity ///style={styles.styleImage}
                                    onPress={() => {
                                    console.log("Onpress en CardOriginCompponent 33")
                                    onPressImg()
                                    }}
                                >

                                    {
                                        Platform.OS === 'ios' ?
                                        <Image
                                        fadeDuration={300}
                                        //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                        source={{ uri: webUrl + imageUrl + '_seedfit.png' }}
                                        style={styleImage}
                                        resizeMode="contain"
                                        // onLoadStart={() => { setLoading(true) }}
                                        // onLoadEnd={() => { setLoading(false) }}
                                        />
                                        :
                                        <Image
                                        fadeDuration={300}
                                        //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                        source={{ uri: webUrl + imageUrl + '_seedfit.png' }}
                                        style={styleImage}
                                        resizeMode="contain"
                                        // onLoadStart={() => { setLoading(true) }}
                                        // onLoadEnd={() => { setLoading(false) }}
                                        />
                                    }  
                                </TouchableOpacity>                        
                            </>                          
                        : imageUrl.endsWith('.jpg') ?
                            <> 
                             <TouchableOpacity //style={styles.styleImage}
                                onPress={() => {
                                    imageUrl.endsWith('.jpg') ?
                                    imageUrl = webUrl + imageUrl + '_seedfit.jpg' 
                                    :
                                    imageUrl.endsWith('.png') ?
                                    imageUrl = webUrl + imageUrl + '_seedfit.png' 
                                    :
                                    imageUrl = webUrl + imageUrl 

                               console.log("Onpress en CardOriginCompponent 44", imageUrl)
                                                            navigation.navigate('Imagen', 
                             {imageUrl}
                            )

                               // onPressImg()
                               }}
                             >
                                {
                                    Platform.OS === 'ios' ?
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri: webUrl + imageUrl + '_seedfit.jpg' }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    // onLoadStart={() => { setLoading(true) }}
                                    // onLoadEnd={() => { setLoading(false) }}
                                    />
                                    :
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri: webUrl + imageUrl + '_seedfit.jpg' }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    // onLoadStart={() => { setLoading(true) }}
                                    // onLoadEnd={() => { setLoading(false) }}
                                    />
                                }  
                                </TouchableOpacity>                        
                            </>
                            :                            
                            null
                        } 
                </View>
            );
    case 'profile':
            return (
                <View style={styles.card}>

                {/* <ActivityIndicator visible={loading} /> */}
                {
                    //.............................................
                    //Sección que pinta video de youtube
                    //.............................................
                    youtubeCode === '' ?
                    null
                    :
                    <View style={styles.image}>
                        <VideoVisor videoNumber={youtubeCode} />
                    </View>
                }
                {
                    imageUrl === null ?
                    null
                    : imageUrl === undefined ?
                    null
                    :
                    imageUrl.includes('.mp4') ?
                        <Video
                        // ref = {video}
                        style={styleImageVideo}
                        source={{
                            uri: imageUrl
                        }}
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />
                        : imageUrl.includes('mov') ?
                        <Video
                            // ref = {video}
                            style={styleImageVideo}
                            source={{
                            uri: imageUrl
                            }}
                            useNativeControls
                            resizeMode="contain"
                            isLooping
                            onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />
                        : imageUrl.endsWith('.jpg') ?
                        <Text
                        style={styleImage}
                        >
                            '_userfit.jpg' 
                        </Text>
                            // <Image
                            // //fadeDuration={300}
                            // //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                            // source={{ uri: webUrl + userId +'_'+ imageUrl.substring(0, 19) + '_userfit.jpg'  }}
                            // style={styleImage}
                            // resizeMode="contain"
                            // // onLoadStart={() => { setLoading(true) }}
                            // // onLoadEnd={() => { setLoading(false) }}
                            // />
                        : imageUrl.endsWith('.png') ?
                            <Image
                            fadeDuration={300}
                            //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                            source={{ uri: webUrl + imageUrl.substring(0, 19) +  '_userfit.png' }}
                            style={styleImage}
                            resizeMode="contain"
                            // onLoadStart={() => { setLoading(true) }}
                            // onLoadEnd={() => { setLoading(false) }}
                            />
                            :
                            null
                        } 
                </View>
            );    
    case 'seedBtnContact':
            return (
                <View >
                    {/* <Text onPress={()=>{
                        console.log("presionaste la imagen", imageUrl)
                    }}>soy la imagen {imageUrl}</Text> */}
                <ActivityIndicator visible={loading} />
                {
                    //.............................................
                    //Sección que pinta video de youtube
                    //.............................................
                    youtubeCode === '' ?
                    null
                    :
                    <View style={styles.image}>
                        <VideoVisor videoNumber={youtubeCode} />
                    </View>
                }
                {
                    imageUrl === null ?
                           <Foundation name="mountains" size={iconSize} color={iconColor} />
                    : imageUrl === undefined ?
                           <Foundation name="mountains" size={iconSize} color={iconColor} />
                    :
                    imageUrl.includes('Poner Foto') ?
                    <Foundation name="mountains" size={iconSize} color={iconColor} />

                    :imageUrl.includes('.mp4') ?
                        <Video
                        // ref = {video}
                        style={styleImageVideo}
                        source={{
                            uri:  imageUrl
                        }}
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />

                    : imageUrl.includes('.mov') ?
                        <Video
                            // ref = {video}
                            style={styleImageVideo}
                            source={{
                            uri: imageUrl
                            }}
                            useNativeControls
                            resizeMode="contain"
                            isLooping
                            onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />
                    
                        :  imageUrl.endsWith('.png') ?
                        <>
                         <TouchableOpacity style={styles.styleImage}
                            onPress={() => {
                            console.log("Onpress en handler Image Dichapp")
                            navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                            }}
                         >
                                {
                                    Platform.OS === 'ios' ?
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri: imageUrl  }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                    :
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri: imageUrl }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                }                          
                         </TouchableOpacity> 
                         </>                         
                        : imageUrl.endsWith('.jpg') ?
                        <>       
                         <TouchableOpacity style={styles.styleImage}
                            onPress={() => {
                            console.log("Onpress en handler Image Dichapp")
                            navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                            }}
                         >
                                {
                                    Platform.OS === 'ios' ?
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri:  imageUrl  }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                    :
                                    <Image
                                    fadeDuration={300}
                                    //defaultSource = {require('../../assets/logo_fixdplanet_2.png')}
                                    source={{ uri:  imageUrl }}
                                    style={styleImage}
                                    resizeMode="contain"
                                    onLoadStart={() => { setLoading(true) }}
                                    onLoadEnd={() => { setLoading(false) }}
                                    />
                                }                          
                            </TouchableOpacity>
                            </>
                            :                           
                            null
                        } 
                </View>
            );
  }


}

const styles = StyleSheet.create({
  card: {
    //borderRadius: 15,
    //flex : 1,
    backgroundColor: colors.aguacateGreen,
    // marginBottom: 20,
    //overflow: "hidden",
  },
  image: {
    //width: 100,//(windowWidth * 1), //'100%',//windowWidth ,//,
    //height: 100 //(windowHeight * .85) //'100%',//windowHeight ,
    width: (windowWidth * 1), //'100%',//windowWidth ,//,
    height: (windowHeight * .85),
    // width: widthImage, //'100%',//windowWidth ,//,
    // height: heightImage //'100%',//windowHeight ,
    // marginTop:(windowHeight * .000),
    // marginBottom:'10%'
  },

});

export default ImageHandlerDichapp